travel = window.travel || {};
travel.bokunWidget = {};
travel.search = {};
// travel.search.afterProcessResponse = '';
travel.search.$form = null;
travel.search.$cards = null;
travel.search.initialized = false;
travel.search.init = function () {
	if (travel.search.initialized) {
		return;
	}
	$('#tourFilterId').on('change', function() {
		let params = new URLSearchParams(window.location.search);
		params.set('tourFilterId', $(this).val());
		if (travel.search.initialized === true) {
			params.delete('owlIndex');
		}
		history.pushState('', '', `?${params.toString()}`);
		var type = $(this).find('option:selected').attr('data-filter');
		$('#tourFilter').val(type);
	});
	$('#regionId').on('change', function() {
		let params = new URLSearchParams(window.location.search);
		params.set('regionId', $(this).val());
		if (travel.search.initialized === true) {
			params.delete('owlIndex');
		}
		history.pushState('', '', `?${params.toString()}`);
	});
	$('#sort').on('change', function() {
		let params = new URLSearchParams(window.location.search);
		params.set('sort', $(this).val());
		if (travel.search.initialized === true) {
			params.delete('owlIndex');
		}
		history.pushState('', '', `?${params.toString()}`);
	});

	$('#finished').on('change', function() {
		let params = new URLSearchParams(window.location.search);
		params.set('finished', ($(this).prop('checked') === true) ? 1 : 0);
		if (travel.search.initialized === true) {
			params.delete('owlIndex');
		}
		history.pushState('', '', `?${params.toString()}`);
	});

	let params = new URLSearchParams(window.location.search);
	const tourFilterId = params.get('tourFilterId');
	if (tourFilterId) {
		$('#tourFilterId').val(tourFilterId).change();
	}
	const regionId = params.get('regionId');
	if (regionId) {
		$('#regionId').val(regionId).change();
	}
	travel.search.$form = $('.travel-search');
	travel.search.$results = $('.results');
	travel.search.$count = $('.count span');
	travel.search.$form.find('.select, select').change(function () {
		travel.search.go();
	});
	travel.search.$form.find('input[type="checkbox"]').change(function () {
		travel.search.go();
	});
	travel.search.$form.find('.radio').click(function () {
		$('body').removeClass('clubId-33').removeClass('clubId-34');
		travel.search.$form.find('.radio').prop('checked', false);
		$(this).prop('checked', true);
		travel.search.go();
	});

	travel.search.$form.find('#clear').click(function () {
		travel.search.clear();
	});
	travel.search.$form.find('#search').click(function () {
		travel.search.go();
		return false;
	});
	travel.search.go();
	travel.search.layout();
	travel.search.hash();
	travel.search.order();
	travel.search.initialized = true;
};

travel.search.initQueryParameters = function(tourFilterId) {
	history.pushState('', '',`?tourFilterId=${tourFilterId.toString()}`);
};

travel.search.updateQueryParams = function(e) {
	let carousel = $('.tour__wrapper.owl-carousel');
	if (!carousel.length) {
		carousel = $('.cards.owl-carousel');
	}
	if (!carousel.length) {
		return;
	}
	const params = new URLSearchParams(window.location.search);
	if (e.item.index && e.item.index > 0) {
		params.set('owlIndex', e.item.index);
	} else {
		params.delete('owlIndex');
	}
	history.pushState('', '',`?${params.toString()}`);
}
travel.search.handleQueryParams = function(e) {
	let carousel = $('.tour__wrapper.owl-carousel');
	if (!carousel.length) {
		carousel = $('.cards.owl-carousel');
	}
	if (!carousel.length) {
		return;
	}
	const params = new URLSearchParams(window.location.search);
	const owlIndex = params.get('owlIndex');
	if (owlIndex) {
		setTimeout(function() {
			carousel.trigger('to.owl.carousel', owlIndex);
		}, 1000);
	}
}

travel.search.go = function () {
	travel.search.clubcheck();
	travel.search.$form.ajaxSubmit({
		dataType: 'json',
		success: travel.search.processResponse
	});
};
// Add bodyclas for selected club
travel.search.clubcheck = function() {
	travel.search.$form.find('#elm_clubId .radio').click(function() {
		var $this = $(this);
		$('body').removeClass('clubId-33').removeClass('clubId-34');
		if($("input[name="+$this.attr('name')+"]:checked").is(':checked')) {
			$('body').addClass($this.attr('id'));
		}
	});
};
travel.search.processResponse = function(responseText, statusText, $xhr, $form) {
	if(responseText.cards.includes('class="col')) {
		travel.search.$results.html(responseText.cards);
	}
	else {
		travel.search.$results.html('<h3 class="noCards">Ekkert í boði þessa stundina í þessum flokki</h3>');
	}
	//var cardsCount = $(responseText.cards).find('.col').length;
	//travel.search.$count.html(cardsCount);
	//travel.search.$count.parent().addClass('show');
	if (travel.search.afterProcessResponse) {
		travel.search.afterProcessResponse(responseText);
	}
	$("img.responsive").responsiveImg();

	var $currentModule = $('#module').val();
	if ($currentModule === 'forsida') {
		site.owl.init('#box_group_trips .cards', {
			onTranslated: travel.search.updateQueryParams,
			onInitialized: travel.search.handleQueryParams,
			loop: false,
			dots: false,
			nav: true,
			mouseDrag:false,
			touchDrag: true,
			margin: 30,
			navText: ["<i class=\"fa fa-angle-left\"></i>", "<div class=\"arrow\"><i class=\"fa fa-angle-right\"></i></div>"],
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				},
				992: {
					items: 4
				}
			}
		});
	}
	else {
		if($('body:not(.tourSearchView), body.layout-cards').length > 0) {
			travel.trailCards();
		}
		else {
			travel.tourCards();
		}
	}

	return false;
};
travel.search.clear = function () {
	travel.search.$form.find('.select').val('-1');
	travel.search.$form.find(':radio').prop('checked', false);
	travel.search.$form.find(':checbox').prop('checked', false);
	travel.search.go();
};

travel.tabs = function() {
	var $tabs = $('#travel').find('.tabs');
	$tabs.find('.menu >li').on('click touchstart',function(e) {
		var $this = $(this);
		var tc =  $('.tabContent.'+$this.attr('id'));
		if(!tc.hasClass('.tabContent.'+$this.attr('id'))) {
			$tabs.find('.menu li').removeClass('selected');
			$tabs.find('.tabContent').removeClass('active');
			$this.addClass('selected');
			tc.addClass('active');
		}

		e.preventDefault();
	});
};

travel.club = {
	init: function () {
		site.owl.init('.club-box .box_custom .cards', {
			loop: false,
			dots: false,
			nav: true,
			mouseDrag: false,
			touchDrag: true,
			margin: 30,
			navText: ["<i class=\"fa fa-angle-left\"></i>", "<div class=\"arrow\"><i class=\"fa fa-angle-right\"></i></div>"],
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				},
				992: {
					items: 4
				}
			}
		});
	}
};


travel.trailCards = function() {

};

travel.tourCards = function() {
	site.owl.init('.cards > .wrap', {
		loop: false,
		dots: false,
		nav: true,
		mouseDrag: false,
		touchDrag: true,
		margin: 30,
		navText: ["<i class=\"fa fa-angle-left\"></i>", "<div class=\"arrow\"><i class=\"fa fa-angle-right\"></i></div>"],
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			992: {
				items: 4
			}
		}
	});
	if($('body.layout-list').length > 0) {
		var owl = $('.owl-carousel');
		owl.trigger('destroy.owl.carousel');
	}
};

travel.tourView = function() {
	site.owl.init('#travel .photosWrapper', {
		loop: true,
		nav: true,
		dots:false,
		margin:0,
		startPosition:1,
		navText:["<i class=\"fa fa-chevron-left\" />","<i class=\"fa fa-chevron-right\" />"],
		items: 2,
		responsiveClass:true,
		responsive:{
			0:{
				items:1,
				nav:true
			},
			767:{
				items:2,

			}
		}
	});
};
travel.loadBokunCartWidget = function () {
	travel.loadBokunWidget(6442, 'w6442_1df6aa66_b0e6_4174_9a89_2c1e7dfe40b1', '');
};

travel.bokunDefaultChannelId = '0d81111e-05c4-4c72-a1d8-ad8f7f6e69c2';
travel.bokunMemberChannelId = '681c7ad5-f453-4291-8656-b7468720f2f3';

travel.loadBokunWidget = function (id, hash, queryString, channelId) {
	var widgetEmbedder;
	var iframeId = '#bokunWidget' + hash;
	var fallbackChannelId = ((Cookies.get('isMember') === 'true') ? travel.bokunMemberChannelId : travel.bokunDefaultChannelId );
	channelId = typeof channelId !== 'undefined' ? channelId : fallbackChannelId;


	if ($(iframeId).length < 1) {
		(function(d, t) {
			var host = 'widgets.bokun.io';
			var frameUrl = 'https://' + host + '/widgets/' + id + '?bookingChannelUUID=' + channelId  + '&amp;lang=' + moya.division + '&amp;ccy=ISK&amp;hash=' + hash + '&amp;' + queryString;

			var s = d.createElement(t), options = {
				'host': host,
				'frameUrl': frameUrl,
				'widgetHash':hash,
				'autoResize':true,
				'height':'',
				'width':'100%',
				'minHeight': 0,
				'async':true,
				'ssl':true,
				'transientSession': true,
				'cookieLifetime': 43200
			};
			s.src = 'https://' + host + '/assets/javascripts/widgets/embedder.js';
			s.onload = s.onreadystatechange = function() {
				var rs = this.readyState; if (rs) if (rs !== 'complete') if (rs !== 'loaded') return;
				try {
					widgetEmbedder = new BokunWidgetEmbedder(); widgetEmbedder.initialize(options); widgetEmbedder.display();
				} catch (e) {}
			};
			var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr);
		})(document, 'script');
	}
};
travel.tour = {};
travel.tour.init = function () {
	var $bokunWidget = $('.bokunWidget');
	if (!$bokunWidget.length) {
		return;
	}

	// if(Cookies.get('hasChosen')) {
	// 	$('.bokunWidget').addClass('noquestion');
	// }

	$('.bokunButton').click(function () {
		$bokunWidget.toggleClass('open');

		// if(Cookies.get('hasChosen')) {
		// 	$('.bokunWidget').addClass('noquestion');
		// 	travel.tour.loadBokunTimeSelectorWidget(Cookies.get('tourChannelId'));
		// }
	});

	$('.memberButtons').find('.button').click(function () {
		//Cookies.set('hasChosen', true);
		var channelId = $(this).hasClass('memberYes') ? travel.bokunMemberChannelId : travel.bokunDefaultChannelId;
		if ($(this).hasClass('memberYes')) {
			Cookies.set('isMember', true);
		} else {
			Cookies.set('isMember', false);
		}

		//Cookies.set('tourChannelId', channelId);
		$(this).parent().find('.button').removeClass('selected');
		$(this).addClass('selected');
		$('.bokunWidget').toggleClass('noquestion');
		travel.tour.loadBokunTimeSelectorWidget(channelId);
	});
};

travel.tour.search = {};
travel.tour.search.counter = 0;
travel.tour.search.afterProcessResponse = function () {
	if (travel.tour.search.counter === 0) {
		var text = $('body').hasClass('is') ? 'Sjá fleiri' : 'See More';
		travel.search.$results.find('.cards.past').addClass('minimal').find('> .wrap').append("<button class='button contactButton'>"+text+"</button>");
		travel.search.$results.find('.button').click(function() {
			var $this = $(this);
			$this.closest('.cards').removeClass('minimal');
			$this.remove();
		});
	} else {
		$('.results').find('.cards').removeClass('minimal');
	}
	travel.tour.search.counter++;
};

travel.tour.loadBokunTimeSelectorWidget = function (channelId) {
	var hash = 'w2149_df4c3bb6_30e5_4ae9_b372_11494ba03482';
	var divId = '#bokun-' + hash;
	var activity = $(divId).data('activity');
	$(divId).html('Loading ...');
	travel.loadBokunWidget(2149, hash, 'activityId=' + activity, channelId);
};
travel.tour.map = {};
travel.tour.map.enabled = 0;
travel.tour.map.coordinates = [];
travel.tour.map.points = [];
travel.tour.map.init = function () {
	if (!travel.tour.map.enabled) {
		return;
	}
	travel.map.init([64.98520948970064, -18.14939865053829], 8, (map) => {
		function createSegmentedPolyline(coords) {
			var polyLayer = L.geoJSON(null, {
				style: {
					color: 'red',
					opacity: 1.0
				},
			});
			for (var i = 0; i < (coords.length - 1); i++) {
				var line = L.polyline([coords[i], coords[i + 1]]);
				polyLayer.addData(line.toGeoJSON());
			}
			return(polyLayer);
		}
		var segmentedPolyline = createSegmentedPolyline(JSON.parse(travel.tour.map.coordinates));
		segmentedPolyline.addTo(map);
		map.fitBounds(segmentedPolyline.getBounds());
	});
};

travel.hut = {};
travel.hut.init = function () {
	var $bokunWidget = $('.bokunWidget');
	travel.tabs();

	$('.bokunButton').click(function () {
		$bokunWidget.toggleClass('open');
		if ($(this).hasClass('skipMemberCheck')) {
			$('.memberButtons').find('.memberNo').trigger('click');
		}
	});

	$('.memberButtons').find('.button').click(function () {
		var channelId = $(this).hasClass('memberYes') ? travel.bokunMemberChannelId : travel.bokunDefaultChannelId;
		if ($(this).hasClass('memberYes')) {
			Cookies.set('isMember', true);
		} else {
			Cookies.set('isMember', false);
		}
		$(this).parent().find('.button').removeClass('selected');
		$(this).addClass('selected');
		$('.bokunWidget').toggleClass('noquestion');

		travel.hut.loadBokunRoomSelectorWidget(channelId);
	});


};
travel.map = {};
travel.map.object = null;
travel.map.markers = [];
travel.map.init = function(center, zoom, postInit = null) {
	MoyaLoader.all([
		'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css',
		'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js',
	]).then(() => {
		const map = L.map('map', {
			center: center,
			zoom: zoom,
			zoomControl: false,
			scrollWheelZoom: false
		});
		L.control.zoom({
			position: 'bottomright'
		}).addTo(map);
		L.tileLayer.wms('https://gis.lmi.is/mapcache/web-mercator/wms?', {
			attribution: '&copy; <a href="https://www.lmi.is" target="_blank">LMÍ</a>',
			layers: 'LMI_Kort',
		}).addTo(map);
		L.tileLayer.wms('https://gis.lmi.is/geoserver/wms?', {
			layers: 'Ornefni',
			transparent: true,
			format: 'image/png',
			version: '1.3.0',
		}).addTo(map);

		if (postInit instanceof Function) {
			postInit(map);
		}
		travel.map.object = map;
	});
}
travel.hut.map = {};
travel.hut.map.enabled = 0;
travel.hut.map.lat = null;
travel.hut.map.lng = null;
travel.hut.map.init = function () {
	if (travel.hut.map.enabled) {
		// Hut location
		travel.map.init([travel.hut.map.lat, travel.hut.map.lng], 11, (map) => {
			L.marker([travel.hut.map.lat, travel.hut.map.lng], {
				icon: L.icon({
					iconUrl: '/static/local/travel/icons/marker_red.png',
					iconSize: [32, 32],
				}),
			}).addTo(map);
		});
	}
};

travel.hut.map.search = {};
travel.hut.map.search.enabled = 1;
travel.hut.map.search.cards = null;
travel.hut.map.search.init = function () {
	if (travel.hut.map.search.enabled) {
		travel.map.init([64.98520948970064, -18.14939865053829], 7);
	}
};
travel.hut.map.search.afterProcessResponse = function (response) {
	const map = travel.map.object;

	travel.map.markers.forEach((marker) => {
		map.removeLayer(marker);
	});

	travel.hut.map.search.coordinates = response.cards;

	if (typeof response.coordinates === 'object') {
		$.each(response.coordinates, function (i, k) {
			var content = document.getElementById('hut_' + i);
			if (content) {
				var iconColor = content.querySelector('.hut__wrapper').getAttribute('data-icon-color') ?? '#0288d1';
				var iconSettings = {
					mapIconUrl: '<svg width="38" height="54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32.567 14.898c0 1.86-.848 4.542-2.152 7.552-1.3 2.998-3.035 6.283-4.773 9.332a192.525 192.525 0 0 1-6.72 10.895l-.368-.555c-.38-.577-.923-1.41-1.575-2.434a192.413 192.413 0 0 1-4.778-7.906c-1.738-3.05-3.473-6.334-4.773-9.332-1.304-3.01-2.152-5.692-2.152-7.552 0-7.536 6.11-13.645 13.646-13.645 7.536 0 13.645 6.109 13.645 13.645z" fill="{mapIconColor}" stroke="#fff" stroke-width=".552" filter="url(#filter0_d_619_2279)"/><path d="M9.88 15.972h.004v-.003l-.003.003zm17.737-.345c0-.1-.043-.19-.111-.252l-8.263-8.266A.345.345 0 0 0 19 7v.012a.344.344 0 0 0-.243.109l-8.263 8.266a.344.344 0 0 0 .233.597h1.96v9.118h4.559v-5.26a.35.35 0 0 1 .35-.35h2.803a.35.35 0 0 1 .35.35v5.262h4.564v-9.132h1.958a.345.345 0 0 0 .346-.345zm.502.357l-.003-.004v.004h.003z" fill="#fff"/><defs><filter id="filter0_d_619_2279" x="0" y=".977" width="37.843" height="52.197" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="5"/><feGaussianBlur stdDeviation="2.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_619_2279"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_619_2279" result="shape"/></filter></defs></svg>',
					mapIconColor: iconColor,
				};
				var divIcon = L.divIcon({
					className: "leaflet-data-marker",
					html: L.Util.template(iconSettings.mapIconUrl, iconSettings),
					iconSize: [22,32],
				});
				var marker = L.marker([k.lat, k.lng], {
					icon: divIcon,
				});
				marker.bindPopup(content.innerHTML);
				marker.addTo(map);
				travel.map.markers.push(marker);
			}
		})
	}
};

travel.hut.loadBokunRoomSelectorWidget = function (channelId) {
	var divClass = '.campingRoomSelector';
	var name = $(divClass).data('name');
	var accommodation = $(divClass).data('accommodation');
	var widget = travel.bokunWidget[name];
	$(divClass).html('Loading ...');
	travel.loadBokunWidget(widget['id'], widget['hash'], 'accommodationId=' + accommodation, channelId)
};

travel.search.layout = function () {
	var $layout = $('.layout');

	$layout.find('a').on('click touchstart',function(e) {
		e.preventDefault();

		var layout = $(this).data('layout'),
			$body = $('body'),
			$this = $(this);
		$this.addClass('active').siblings().removeClass('active');

		$body.removeClass (function (index, className) {
			return (className.match (/(^|\s)layout-\S+/g) || []).join(' ');
		});
		$body.addClass('layout-' + layout);

		document.cookie = $layout.data('type') + 'Layout=' + layout + '; path=/';

		if($('body:not(.tourSearchView)').length > 0) {
			travel.trailCards();
		}
		else {
			travel.tourCards();
		}
		if($('body.club-box')) {
			travel.club.init();
		}
		if (layout === 'map' && travel.map.object) {
			travel.map.object._onResize();
		}
	});
};

travel.search.hash = function() {
	$('label', '.eType_radio').each(function(e) {
		var $this = $(this),
			codename = $this[0].innerText;
		codename = codename.trim().replace(/\s+/g, '-').toLowerCase();
		var special = {á:'a', ð:'d', é:'e', í:'i', ó:'o', ú:'u', ý:'y', þ:'th', æ:'ae',ö:'o'};
		var r;
		for(var i in special){
			r = new RegExp(i,"g");
			codename = codename.replace(r,special[i]);
		}
		$this.find('input').addClass(codename);
	});

	var hash = window.location.hash.substr(1);

	if (hash) {
		$('input.' + hash).click();
		window.location.hash = '';
	}
};

travel.search.order = function() {
	$('select#sort').on('change', function() {
		var value = this.value.toString(),
			sortedCards = '',
			cards = $('.cards');

		if (value === 'date') {
			sortedCards = $('.cards .col').sort(function(a,b) {
				if($(a).data('index') > $(b).data('index')) {
					return 1
				} else if ($(a).data('index') < $(b).data('index')) {
					return -1;
				}
				return 0;
			});
		}
		else if (value === 'difficulty') {
			sortedCards = $('.cards .col').sort(function(a,b) {
				if ($(a).data('difficulty') > $(b).data('difficulty')) {
					return 1;
				} else if($(a).data('difficulty') < $(b).data('difficulty')) {
					return -1;
				}
				return 0;
			});
		}
		else if (value === 'asc') {
			sortedCards = $('.cards .col').sort(function(a,b) {
				if($(a).find('h3').text() > $(b).find('h3').text()) {
					return 1;
				} else if ($(a).find('h3').text() < $(b).find('h3').text()) {
					return -1;
				}
				return 0;
			});
		}

	});
};

travel.image = {};
travel.image.initDone = false;
travel.image.deleteConfirmLabel = '';
travel.image.coverConfirmLabel = '';
travel.image.upload =  {
	init: function(urls, lang) {
		$('.image a.delete').click(function () {
			if (confirm(travel.image.deleteConfirmLabel)) {
				$.post($(this).attr('href'), function() {
					window.location.reload();
				});
			}
			return false;
		});
		$('.image a.coverimage').click(function () {
			if (confirm(travel.image.coverConfirmLabel)) {
				$.post($(this).attr('href'), function() {
					window.location.reload();
				});
			}
			return false;
		});
		if(travel.image.initDone === false) {
			travel.image.initDone = true;
			$('ul#images').sortable({
				'opacity': 0.8,
				'update': function (e, ui) {
					var $el = $(this);
					$el.sortable('disable').addClass('disabled');
					$.post(urls.sort, $(this).sortable('serialize'), function (d) {
						if (d.success !== true) {
							moya.message.add(lang.galleryErrorOnSave);
							$el.sortable('cancel');
						}
						$el.removeClass('disabled');
						$el.sortable('enable');
					});
				}
			});
			$('#ffile').uploadify({
				'uploader': '/_moya/js/jquery/uploadify/uploadify.swf',
				'script': urls.script,
				'cancelImg': '/_moya/js/jquery/uploadify/cancel.png',
				'auto': true,
				'multi': true,
				'folder': '/tmp',
				'fileDesc': lang.galleryImageUploadFileDescription,
				'fileExt': '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG,*.pdf;*.PDF;*.doc;*.docx;*',
				'buttonText': lang.galleryFileBrowse,
				'queueID': 'ffileQueue',
				'onError': function () {
					$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
				},
				'onComplete': function (e, q, f, r) {
					var n = $('#notice');
					switch (r) {
						case 'noAlbum':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
							break;
						case 'noSave':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
							break;
					}
				},
				'onAllComplete': function () {
					window.location.reload();
				}
			});
		}
	}
};
